<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container" style="padding-bottom: 20px">
      <div class="dashboardAdmin-header position-relative">
        <div
          class="
            dashboardAdmin-header-main-head
            ml-2
            d-flex
            justify-content-between
            bluebtn
          "
        >
          <span>Customers</span>
          <b-button
            v-if="!roles.includes('EXTERNAL_ACCESS')"
            class="acs-addBtn-modal"
            @click="openExcel = !openExcel"
            ref="excelButton"
          >
            Export Excel
          </b-button>
        </div>

        <div class="custom-duration-menu p-3" v-if="openExcel" ref="closeCard">
          <div class="topDiv mt-3" ref="recdropdown1">
            <DateField
              :label="'From Date'"
              :mandatory="false"
              :placeholder="'Enter From Date'"
              :id="'start-date-disable'"
              :format="'DD-MM-YYYY'"
              :vmodel="fromDate"
              @select-value="fromDate = $event"
              :endDate="toDate"
            />
          </div>
          <div class="topDiv mt-3">
            <DateField
              :label="'To Date'"
              :mandatory="false"
              :placeholder="'Enter To Date'"
              :id="'to-date-special'"
              :format="'DD-MM-YYYY'"
              :vmodel="toDate"
              @select-value="toDate = $event"
              :startDate="fromDate"
            />
          </div>

          <div class="d-flex justify-content-between mt-4 bluebtn">
            <b-button class="acs-cancelBtn-filter" @click="closeExportExcel()"
              >Cancel</b-button
            >

            <b-button
              class="acs-cancelBtn-filter"
              :disabled="fromDate == '' || toDate == ''"
              @click="exportExcelData()"
              >Export</b-button
            >
          </div>
        </div>
      </div>

      <div class="d-flex mt-2 h-93">
        <div
          class="wb-new-container"
          :class="
            allcustomerDetails.length == 0 && searchQuery == ''
              ? 'relativeclass w-100'
              : 'w-70'
          "
          ref="scrollToMe"
        >
          <div class="d-flex align-items-center justify-content-between mb-2">
            <div
              class="fw-bold wb-subheading"
              v-if="
                allcustomerDetails.length != 0 ||
                (allcustomerDetails.length == 0 && searchQuery != '')
              "
            >
              List of customers
            </div>
            <div
              class="relativeclass"
              v-if="
                allcustomerDetails.length != 0 ||
                (allcustomerDetails.length == 0 && searchQuery != '')
              "
            >
              <div class="IHD-filter-count mb-3" v-if="filterApplied"></div>
              <div class="bluebtn" ref="filter-btn">
                <b-button class="acs-addBtn" @click="openFilterBox"
                  ><img
                    class="mr-2"
                    src="../../assets/img/accessconnew/whiteFilter.svg"
                    alt=""
                  />Filter</b-button
                >
              </div>
              <div
                v-if="openFilter"
                class="acs-filter p-3"
                ref="filter-box"
                v-closable="{
                  exclude: ['filter-btn', 'filter-box'],
                  handler: 'hideFilterBox',
                }"
              >
                <div>
                  <div>
                    <div class="acs-black-txt">Sort By :</div>
                    <div
                      @click="(sortCard = !sortCard), (typeCard = false)"
                      class="acs-filter-dropdown mt-2 position-relative pointer"
                    >
                      <span class="newManage-dropdown-place">
                        {{ sortName }}
                      </span>
                      <img
                        v-if="!sortCard"
                        class="mr-2"
                        src="../../assets/img/accessconnew/blueDownArrowSmall.svg"
                        alt=""
                      />
                      <img
                        v-else
                        class="mr-2"
                        src="../../assets/img/accessconnew/uparrow-blue-small.svg"
                        alt=""
                      />
                    </div>
                    <div v-if="sortCard" class="relativeclass">
                      <div class="newInt-radio-dropdown p-0">
                        <b-form-group class="sec-mcq-datacard">
                          <b-form-radio-group
                            class="newInt-radio-dropdown-inner-content w-100"
                            size="sm"
                            v-model="customerSort"
                            :options="formatSortOptions"
                            @change="sortCard = false"
                            buttons
                            stacked
                          >
                          </b-form-radio-group>
                        </b-form-group>
                      </div>
                    </div>
                  </div>
                  <div class="bluebtn d-flex justify-content-between mt-4">
                    <b-button class="acs-cancelBtn-filter" @click="cancelFilter"
                      >Cancel</b-button
                    >
                    <div class="d-flex">
                      <b-button
                        class="acs-cancelBtn-filter mr-3"
                        @click="resetFilter"
                        >Reset</b-button
                      >
                      <b-button
                        class="acs-cancelBtn-filter"
                        @click="applyFilterMethod"
                        >Apply</b-button
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr
            class="my-0"
            v-if="
              allcustomerDetails.length != 0 ||
              (allcustomerDetails.length == 0 && searchQuery != '')
            "
          />
          <div
            class="overflow-auto pl-2"
            @scroll="onScroll"
            style="height: calc(100vh - 215px)"
          >
            <div
              class="
                d-flex
                flex-column
                align-items-center
                justify-content-center
              "
              style="height: calc(100vh - 230px)"
              v-if="
                searchQuery !== '' &&
                allcustomerDetails.length === 0 &&
                searchQuery !== 'Loader' &&
                !LoaderStatus
              "
            >
              <div>
                <img
                  src="../../assets/img/accessconnew/emptyprivilageBig.svg"
                  alt=""
                />
              </div>
              <div class="mt-3 w-100 text-center">
                <span class="searchnotfound"
                  >No matching results for
                  <span class="searchtext wordbreak">
                    "{{ searchQuery }}"
                  </span>
                  .</span
                >
              </div>
            </div>
            <div
              v-if="
                searchQuery == '' &&
                allcustomerDetails.length == 0 &&
                LoaderStatus == false
              "
              class="
                d-flex
                flex-column
                align-items-center
                justify-content-center
                h-100
                w-100
              "
            >
              <div class="">
                <img src="../../assets/nocust.svg" alt="" />
              </div>
              <div
                v-if="
                  roleValues.roles.includes('Lead Recruiter') ||
                  roleValues.roles.includes('Recruiter')
                "
                class="nosearchfound-text text-center"
              >
                There are no tagged customers
              </div>
              <div v-else class="nosearchfound-text text-center">
                There is no data available. Go to Manage section And click on
                the
                <strong> “Create New Customer”</strong>
                button to add customers
              </div>
            </div>
            <div class="d-flex flex-wrap">
              <transition-group
                name="cell"
                class="d-flex flex-wrap pb-2"
                tag="div"
              >
                <div
                  class="relativeclass"
                  :class="[
                    selectedCustomer.customerID != cust.customerID
                      ? 'tp-cardv-main'
                      : 'tp-cardv-main-active',
                    cust.active && roles.includes('GET_JOB') ? 'pointer' : '',
                  ]"
                  v-for="cust in allcustomerDetails"
                  :key="cust.customerID"
                  @click="
                    roles.includes('GET_JOB') && cust.active
                      ? goToDashboard(cust)
                      : ''
                  "
                >
                  <div
                    class="
                      tp-cardhead
                      d-flex
                      justify-content-between
                      align-items-center
                    "
                  >
                    <div style="width: 10%">
                      <img
                        v-if="cust.customerType == '1'"
                        src="../../assets/New-imgs/CustVend-icons/new int icon.svg"
                        alt=""
                      />
                      <img
                        v-else
                        src="../../assets/New-imgs/CustVend-icons/new client icon.svg"
                        alt=""
                      />
                    </div>
                    <div
                      class="relativeclass"
                      style="width: 80%"
                      v-if="cust.active"
                    >
                      <div class="text-truncate pt-1 ml-2">
                        <span
                          v-b-tooltip.hover.bottom="cust.name"
                          class="
                            d-inline-block
                            text-truncate
                            wb-custcards-heading
                          "
                          style="max-width: 100%"
                        >
                          {{ cust.name }}</span
                        >
                      </div>
                    </div>
                    <div v-else class="relativeclass" style="width: 80%">
                      <div class="text-truncate ml-2 pt-1">
                        <span
                          v-b-tooltip.hover.bottom="cust.name"
                          class="
                            d-inline-block
                            text-truncate
                            wb-custcards-heading
                          "
                          style="max-width: 100%"
                        >
                          {{ cust.name }}</span
                        >
                      </div>
                    </div>
                    <div class="d-flex align-items-center" style="width: 10%">
                      <div class="pointer d-flex align-items-center">
                        <div class="pointer">
                          <img
                            @click.stop="
                              viewCustomer(cust), (openExcel = false)
                            "
                            v-if="
                              selectedCustomer.customerID != cust.customerID
                            "
                            class="imageshover"
                            v-b-popover.hover.top="'View'"
                            src="../../assets/New-imgs/interviewProcess-icons/newInt-eyeicon.svg"
                            alt=""
                          />
                          <img
                            class="imageshover"
                            v-b-popover.hover.top="'Hide'"
                            src="../../assets/New-imgs/interviewProcess-icons/newInt-notview-icon.svg"
                            alt=""
                            v-else
                            @click.stop="hideDetails"
                          />
                        </div>
                        <!-- <div class="ml-2 pff-card-icon-container pointer">
                          <img
                            src="../../assets/img/newworkbench/Edit.svg"
                            alt=""
                          />
                        </div>
                        <div class="ml-2 pff-card-icon-container pointer">
                          <img
                            src="../../assets/img/newworkbench/delete.svg"
                            alt=""
                          />
                        </div> -->
                      </div>
                    </div>
                  </div>
                  <div
                    class="
                      d-flex
                      justify-content-around
                      d-flex
                      align-items-center
                      new-wb-subcards
                    "
                  >
                    <div class="d-flex align-items-center flex-column">
                      <div v-if="cust.jobs < 10" class="wb-new-greenfont">
                        0{{ cust.jobs }}
                      </div>
                      <div v-else class="wb-new-greenfont">
                        {{ cust.jobs }}
                      </div>
                      <div class="wb-new-greyfont">Jobs</div>
                    </div>

                    <div class="d-flex align-items-center flex-column">
                      <div v-if="cust.openings < 10" class="wb-new-bluefont">
                        0{{ cust.openings }}
                      </div>
                      <div v-else class="wb-new-bluefont">
                        {{ cust.openings }}
                      </div>
                      <div class="wb-new-greyfont">Openings</div>
                    </div>
                    <div class="d-flex align-items-center flex-column">
                      <div v-if="cust.selected < 10" class="wb-new-yellowfont">
                        0{{ cust.selected }}
                      </div>
                      <div v-else class="wb-new-yellowfont">
                        {{ cust.selected }}
                      </div>
                      <div class="wb-new-greyfont">Selected</div>
                    </div>
                  </div>
                  <div class="inactive-text-box-pfbk" v-if="!cust.active">
                    <div class="inactive-txt">Inactive</div>
                  </div>
                </div>
              </transition-group>
            </div>
            <div
              style="margin: auto"
              v-if="showLoader"
              class="d-flex justify-content-center"
            >
              <b-spinner label="Loading..."></b-spinner>
            </div>
          </div>
        </div>
        <div
          class="wb-new-container relativeclass ml-2 w-30"
          v-if="
            allcustomerDetails.length != 0 ||
            (allcustomerDetails.length == 0 && searchQuery != '')
          "
        >
          <div
            class="
              d-flex
              align-items-center
              justify-content-center
              flex-column
              h-100
            "
            v-if="!showdetails"
          >
            <div class="">
              <img
                src="../../assets/img/newworkbench/emptydetails.svg"
                alt=""
              />
            </div>
            <div
              class="
                mt-3
                ml-5
                wb-custdetails-empty-txt
                d-flex
                justify-content-center
                text-center
              "
            >
              Click on the eye icon to view <br />
              customer details
            </div>
          </div>
          <div v-if="showdetails" class="">
            <div class="newInt-rs-mainhead mt-2 ml-2">Customer Details</div>
            <hr />
            <div
              class="mt-1 mr-2 mb-1"
              :class="
                !selectedCustomer.active
                  ? 'manage-right-container-bottom-inactive'
                  : 'manage-right-container-bottom'
              "
            >
              <div
                class="mt-3"
                v-for="(field, index) in customFields[
                  selectedCustomer.customerType
                ]"
                :key="index"
              >
                <div class="newInt-rs-head">{{ field.label }}</div>

                <div v-if="checkFieldKeys(field)">-</div>
                <div
                  class="newInt-rs-subhead"
                  style="word-break: keep-all"
                  v-else-if="Object.keys(selectedCustomer).length > 0"
                >
                  <template v-if="isHtmlContent(field)">
                    <div v-html="checkValuesOfKey(field)"></div>
                  </template>
                  <template v-else>
                    {{ checkValuesOfKey(field) }}
                  </template>
                </div>
              </div>
              <div v-if="this.leadKey">
                <div class="newInt-rs-head mt-3">Created At</div>
                <div class="newInt-rs-subhead wordbreak">
                  {{ formattedCreatedAt }}
                </div>
              </div>
              <hr />
              <div
                class="
                  mt-3
                  d-flex
                  align-items-center
                  justify-content-between
                  manange-opngs-container
                "
              >
                <div class="d-flex align-items-center">
                  <div>
                    <img
                      src="../../assets/New-imgs/CustVend-icons/manage-openings-icon.svg"
                      alt=""
                    />
                  </div>
                  <div class="ml-3 manange-opngs-container-font">Openings</div>
                </div>
                <div class="manange-opngs-container-count">
                  {{ selectedCustomer.openings }}
                </div>
              </div>

              <div
                class="
                  mt-3
                  d-flex
                  align-items-center
                  justify-content-between
                  manange-opngs-container
                "
              >
                <div class="d-flex align-items-center">
                  <div>
                    <img
                      src="../../assets/New-imgs/CustVend-icons/manage-inprogress-icon.svg"
                      alt=""
                    />
                  </div>
                  <div class="ml-3 manange-opngs-container-font">
                    In Progress
                  </div>
                </div>
                <div class="manange-opngs-container-count">
                  {{ selectedCustomer.inprogress }}
                </div>
              </div>

              <div
                class="
                  mt-3
                  d-flex
                  align-items-center
                  justify-content-between
                  manange-opngs-container
                "
              >
                <div class="d-flex align-items-center">
                  <div>
                    <img
                      src="../../assets/New-imgs/CustVend-icons/manage-cand-icon.svg"
                      alt=""
                    />
                  </div>
                  <div class="ml-3 manange-opngs-container-font">
                    Candidates
                  </div>
                </div>
                <div class="manange-opngs-container-count">
                  {{ selectedCustomer.candidates }}
                </div>
              </div>

              <div
                class="
                  mt-3
                  d-flex
                  align-items-center
                  justify-content-between
                  manange-opngs-container
                "
              >
                <div class="d-flex align-items-center">
                  <div>
                    <img
                      src="../../assets/New-imgs/CustVend-icons/manage-full-icon.svg"
                      alt=""
                    />
                  </div>
                  <div class="ml-3 manange-opngs-container-font">Fulfilled</div>
                </div>
                <div class="manange-opngs-container-count">
                  {{ selectedCustomer.fulfilled }}
                </div>
              </div>

              <div
                class="
                  mt-3
                  d-flex
                  align-items-center
                  justify-content-between
                  manange-opngs-container
                "
              >
                <div class="d-flex align-items-center">
                  <div>
                    <img
                      src="../../assets/New-imgs/CustVend-icons/manage-cancel-icon.svg"
                      alt=""
                    />
                  </div>
                  <div class="ml-3 manange-opngs-container-font">Cancelled</div>
                </div>
                <div class="manange-opngs-container-count">
                  {{ selectedCustomer.cancelled }}
                </div>
              </div>
            </div>
            <div
              v-if="!selectedCustomer.active"
              class="d-flex align-items-center justify-content-end"
              style="height: 50px; border-top: 1px solid rgba(0, 0, 0, 0.1)"
            >
              <div
                class="pointer bluebtn"
                @click="activateCustModal(selectedCustomer)"
              >
                <b-button class="new-blueBtn">
                  <img
                    src="../../assets/New-imgs/interviewProcess-icons/newInt-activateBtn.svg"
                    alt=""
                    class="mr-2 mb-1"
                  />
                  <span> Activate </span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import toast from "../../components/mixin/toast";
import DateField from "../../components/InputComponents/DateField";

import Spinner from "../../components/fixedcomponents/Spinner.vue";
import { DateTime as LuxonDateTime } from "luxon";
import {
  getRecruiterExcel,
  getCustomer,
  getCustomerFields,
  getLeadStatus,
} from "../../utils/apiFunctions";
import { getCustomerDetails } from "../../utils/apiClient/jobs";
import {
  checkFieldKeys,
  isHtmlContent,
  checkValuesOfKey,
} from "../../utils/customFields";
export default {
  name: "workBench",
  components: {
    Spinner,
    DateField,
  },
  data() {
    // NUMBERS
    return {
      total: 0,
      openExcel: false,
      page: 0,
      count: 20,
      type: 1,
      pageEnd: null,
      fromDate: "",
      toDate: "",

      // BOOLEANS
      filterApplied: false,
      openFilter: false,
      showLoader: false,
      showdetails: false,
      LoaderStatus: false,
      sortCard: false,
      typeCard: false,
      leadKey: null,

      // STRINGS
      customerType: "1",
      prevCustomerType: "1",
      preview: "",
      customerSort: "6",
      prevCustomerSort: "6",
      sortOrder: "-1",
      sortColumn: "updatedAt",
      jdtypeselected: "Active",
      startdatetime: LuxonDateTime.local().minus({ month: 0, days: 0 }).toISO(),

      // OBJECTS
      selectedCustomer: {},
      customFields: {
        1: [],
        2: [],
      },
      exportExcel: {
        startTime: "",
        endTime: "",
      },

      // ARRAYS
      allcustomerDetails: [],
      sortOptions: [
        { text: "Name(Asce)", value: "1" },
        { text: "Name(Desc)", value: "2" },
        { text: "Date Created(Asce)", value: "3" },
        { text: "Date Created(Desc)", value: "4" },
        { text: "Date Modified(Asce)", value: "5" },
        { text: "Date Modified(Desc)(Default)", value: "6" },
      ],
      jdtypeoptions: [
        { text: "All", value: "2" },
        { text: "Active", value: "1" },
        { text: "Inactive", value: "0" },
      ],
    };
  },
  mixins: [toast],
  computed: {
    formattedCreatedAt() {
      const createdAt = this.selectedCustomer.createdAt.substring(0, 10);
      return this.convertDateToDDMMYYYY(createdAt);
    },
    formatSortOptions() {
      if (!this.leadKey) {
        const modifiedOption = this.sortOptions.find(
          (option) => option.value === "6"
        );
        if (modifiedOption) {
          modifiedOption.text = "Recent";
        }
        return this.sortOptions.filter(
          (option) => option.value <= 2 || option.value == 6
        );
      } else {
        return this.sortOptions;
      }
    },

    formattedDate() {
      const dateObj = new Date(this.selectedCustomer.createdAt);
      const day = dateObj.getDate().toString().padStart(2, "0");
      const month = (dateObj.getMonth() + 1).toString().padStart(2, "0");
      const year = dateObj.getFullYear().toString();
      return `${day}-${month}-${year}`;
    },
    minDate() {
      return this.exportExcel.startTime;
    },
    ...mapGetters(["roles"]),
    ...mapGetters("searchVUEX", {
      searchQuery: "getSearchQuery",
    }),
    ...mapGetters("userVUEX", {
      roleValues: "getRoleValues",
    }),
    sortName() {
      if (this.customerSort == "1") {
        return "Name(Asce)";
      } else if (this.customerSort == "2") {
        return "Name(Desc)";
      } else if (this.customerSort == "3") {
        return "Date Created(Asce)";
      } else if (this.customerSort == "4") {
        return "Date Created(Desc)";
      } else if (this.customerSort == "5") {
        return "Date Modified(Asce)";
      } else if (this.customerSort == "6" && !this.leadKey) {
        return "Recent";
      } else {
        return "Date Modified(Desc)";
      }
    },
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue != oldValue) {
        if (newValue != "Loader") {
          this.resetPagination();
        }
      }
    },

    // Watch for these variables to change
    // customerType() {
    //   this.$router.push({
    //     name: `workBench`,
    //     query: {
    //       type: this.customerType,
    //       sort: this.customerSort,
    //     },
    //   });
    // },
    // customerSort() {
    //   this.$router.push({
    //     name: `workBench`,
    //     query: {
    //       type: this.customerType,
    //       sort: this.customerSort,
    //     },
    //   });
    // },
  },
  mounted() {
    document.body.addEventListener("mousedown", this.handleClose);
  },
  beforeDestroy() {
    document.body.removeEventListener("mousedown", this.handleClose);
  },
  created() {
    this.LoaderStatus = true;
    this.$store.commit("searchVUEX/saveSearchQuery", "");
    this.$store.commit("jobDescriptionVUEX/saveFeedBackObject", {});
    this.$store.commit("jobDescriptionVUEX/saveInterviewObject", {});
    this.$store.commit("jobDescriptionVUEX/saveAssesmentData", []);
    // Managing tab redirect based on Customer type and Sort
    this.tabRedirect();
    this.getCustomFields("2");
    this.getCustomFields("3");
  },
  methods: {
    closeExportExcel() {
      this.openExcel = false;
      this.fromDate = "";
      this.toDate = "";
    },
    handleClose(event) {
      if (!event) return;
      if (
        this.$refs.closeCard &&
        !this.$refs.closeCard?.contains(event.target) &&
        !this.$refs.excelButton?.contains(event.target) &&
        !document
          .getElementsByClassName("mx-calendar")[0]
          ?.contains(event.target)
      ) {
        this.closeExportExcel();
      }
    },
    ...mapMutations("jobDescriptionVUEX", {
      saveCustomerDetail: "saveCustomerDetail",
    }),
    hideDetails() {
      this.selectedCustomer = {};
      this.showdetails = false;
    },
    checkFieldKeys(field) {
      return checkFieldKeys(field, this.selectedCustomer);
    },
    isHtmlContent(field) {
      return isHtmlContent(field, this.selectedCustomer);
    },
    checkValuesOfKey(field) {
      return checkValuesOfKey(field, this.selectedCustomer);
    },

    async getLead() {
      try {
        const res = await getLeadStatus();
        this.leadKey = res.data.data.lead;
        this.$forceUpdate();
      } catch (error) {
        console.error(error);
      }
    },
    async getCustomFields(data) {
      try {
        let payload = {
          parentID: data,
        };
        const res = await getCustomerFields(payload);
        if (res.status == 200) {
          this.customFields[parseInt(data) - 1] = res.data.data.fields;
        }
      } catch (error) {
        console.error(error);
      }
    },
    openFilterBox() {
      this.openFilter = !this.openFilter;
      if (this.openFilter) {
        this.prevCustomerSort = this.customerSort;
        this.prevCustomerType = this.customerType;
      }
    },
    resetFilter() {
      this.customerSort = "6";
      this.customerType = "1";
      this.openFilter = false;
      this.filterApplied = false;
      this.saveSort();
    },
    cancelFilter() {
      this.openFilter = false;
      this.sortCard = false;
      this.typeCard = false;
      this.customerSort = this.$route.query.wsort || "6";
      this.customerType = this.$route.query.wtype || "1";
    },
    hideFilterBox() {
      this.openFilter = false;
      this.cancelFilter();
    },
    applyFilterMethod() {
      this.openFilter = false;
      this.filterApplied = true;
      this.saveSort();
    },
    // Managing tab redirect based on Customer type and Sort
    tabRedirect() {
      if (this.$route.query.wsort || this.$route.query.wtype) {
        this.customerSort = this.$route.query.wsort;
        this.customerType = this.$route.query.wtype;
        this.saveSort();
        return;
      }
      this.resetPagination();
    },
    clearExport() {
      this.exportExcel.startTime = "";
      this.exportExcel.endTime = "";
    },
    onScroll(e) {
      // Get the target element of the scroll event.
      const { target } = e;
      // Check if the user has reached the bottom of the scrollable area.
      if (
        Math.ceil(target.scrollTop) >=
        target.scrollHeight - target.offsetHeight
      ) {
        // Check if there is more data to load.
        if (
          this.checkbetween(this.pageEnd, 0, this.total) &&
          !this.showLoader &&
          this.allcustomerDetails.length
        ) {
          this.showLoader = true;
          this.page++;

          this.getCustomers();
        }
      }
    },
    checkbetween(x, min, max) {
      // Return `true` if `x` is between `min` and `max`, otherwise `false`.
      return x > min && x < max;
    },
    resetPagination() {
      this.allcustomerDetails = [];
      this.page = 0;
      this.LoaderStatus = true;
      this.showLoader = false;
      this.getLead();
      this.getCustomers();
    },

    async getCustomers() {
      let payload = {
        searchQuery: this.searchQuery,
        sortColumn: this.sortColumn,
        sortOrder: this.sortOrder,
        type: this.customerType,
        page: this.page,
        count: this.count,
      };
      if (payload.searchQuery == "") {
        delete payload.searchQuery;
      }
      let res = await getCustomer(payload);
      if (res.status == 200) {
        this.total = res.data.data.total;
        if (this.page == 0) {
          this.allcustomerDetails = res.data.data.data;
        } else {
          this.allcustomerDetails = [
            ...this.allcustomerDetails,
            ...res.data.data.data,
          ];
        }
        this.pageEnd = res.data.data.pageEnd;
        this.LoaderStatus = false;
        this.showLoader = false;
        // this.showLoader = res.data.data.total !== res.data.data.pageEnd;
      }
    },
    convertDateToDDMMYYYY(date) {
      const [year, month, day] = date.split("-");
      return `${day}-${month}-${year}`;
    },

    convertDateToYYYYMMDD(date) {
      const [day, month, year] = date.split("-");
      return `${year}-${month}-${day}`;
    },

    async exportExcelData() {
      let time = "T00:00:00.000Z";
      const startDate = this.convertDateToYYYYMMDD(this.fromDate);
      const endDate = this.convertDateToYYYYMMDD(this.toDate);
      try {
        const payload = {
          startTime: startDate + time,
          endTime: endDate + time,
        };

        const res = await getRecruiterExcel(payload);
        if (res.status === 200) {
          this.closeExportExcel();
          const downloadLink = document.createElement("a");
          downloadLink.href = res.data.data.S3link;
          downloadLink.setAttribute("download", "filename.xlsx");
          downloadLink.style.display = "none";
          document.body.appendChild(downloadLink);
          downloadLink.click();
          document.body.removeChild(downloadLink);
          this.successModal("Excel exported successfully!");
        } else {
          this.errorModal(res.data.Detail);
        }
      } catch (error) {
        this.errorModal("Something went wrong");
        throw new Error(`Failed! status:${error.status}`);
      }
    },

    hideexportexcel() {
      this.openExcel = false;
    },

    async viewCustomer(customer) {
      this.openFilter = false;
      try {
        const payload = {
          customerID: customer.customerID,
          openings: customer.openings,
          selected: customer.selected,
          jobIDs: customer.jobIDs,
          lead: customer.lead,
        };
        const response = await getCustomerDetails(payload);
        this.selectedCustomer = response.data.data;
      } catch (error) {
        console.error(error);
      }
      this.showdetails = true;
    },

    goToDashboard(cust) {
      this.saveCustomerDetail(cust);
      this.$router.push({
        name: `InternalHiringDashboard`,
        params: {
          cardName: cust.name,
          customerID: cust.customerID,
        },
        query: {
          wtype: this.customerType,
          wsort: this.customerSort,
          itype: "Active",
        },
      });
    },
    getCustomerValue() {
      this.LoaderStatus = true;
      if (this.jdtypeselected == "Active") {
        this.type = 1;
      } else if (this.jdtypeselected == "Inactive") {
        this.type = 0;
      } else {
        this.type = 2;
      }
      this.showdetails = false;
      this.selectedCustomer = {};
      this.preview = "";
      this.resetPagination();
    },

    saveSort() {
      switch (this.customerSort) {
        case "1":
          this.sortColumn = "name";
          this.sortOrder = "1";
          break;
        case "2":
          this.sortColumn = "name";
          this.sortOrder = "-1";
          break;
        case "3":
          this.sortColumn = "createdAt";
          this.sortOrder = "1";
          break;
        case "4":
          this.sortColumn = "createdAt";
          this.sortOrder = "-1";
          break;
        case "5":
          this.sortColumn = "updatedAt";
          this.sortOrder = "1";
          break;
        default:
          this.sortColumn = "updatedAt";
          this.sortOrder = "-1";
      }
      this.$router.push({
        name: `workBench`,
        query: {
          wtype: this.customerType,
          wsort: this.customerSort,
        },
      });
      this.resetPagination();
    },
  },
};
</script>

<style scoped>
.tnt-sortcard .custom-control {
  padding-left: 2rem;
  padding-top: 5px;
  padding-bottom: 5px;
}
.sort-radio:nth-child(even) {
  background: #fdfdfd;
}
.sort-radio:nth-child(odd) {
  background: #f4f4f4;
}
.cell:nth-child(3n) {
  margin-right: 0;
}

.cell:nth-child(27n) {
  margin-bottom: 0;
}

.cell-move {
  transition: transform 1s;
}
.tp-cardhead {
  position: relative;
  font-size: var(--size-14);
  font-weight: var(--weight-M);
  color: var(--bg-primary);
}

.tp-cardv-submain {
  height: 73px;
  background: #ffffff;
  box-shadow: 0px 0px 12px rgba(0, 0, 0, 0.15);
  border-radius: 10px;
}
.nosearchfound-text {
  font-family: Montserrat;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
}

.wb-newline {
  width: 30px;
  height: 0px;
  background: #f0f0f0;
  border: 1px solid #f0f0f0;
  transform: rotate(90deg);
}

.wbsmalltext {
  font-style: normal;
  font-weight: 400;
  font-size: 11px;
  line-height: 16px;
  color: #72738e;
}

.wb-inner-new-card {
  position: absolute;
  bottom: 17px;
  width: 273px;
  height: 73px;
  background: #ffffff;
  box-shadow: 0px 0px 2px rgb(0 0 0 / 10%);
  border-radius: 10px;
  margin: 0px 10px;
}

.wb-new-text {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  margin: 15px;
  color: #696969;
}

.wb-greenfont {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #038e00;
}
.searchnodata {
  transform: translate(-35px, 0px);
}

.wb-bluefont {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #5782ff;
}

.wb-yellowfont {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  color: #ffc145;
}

.export-card {
  background: var(--bg-white);
  box-sizing: border-box;
  box-shadow: 0px 1px 4px rgb(0 0 0 / 25%);
  border-radius: 5px;
  top: 49px;
  right: 10px;
  padding: 0px 5px;
  position: absolute;
  z-index: 7;
  width: 250px;
  font-size: var(--size-13);
  color: #545454;
}

.wb-nocard-selected-font {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;

  color: #696969;
}
.wb-eye-font {
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  color: #696969;
}

.exportCalenderInput > input {
  width: 100%;
  padding: 0.25rem;
}

.custom-duration-menu {
  position: absolute;
  background: #ffffff;
  right: 10px;
  top: 45px;
  box-shadow: 0 0 15px #82828290;
  border-radius: 6px;
  width: 280px;
}
</style>
